import { render, staticRenderFns } from "./DynamicTextarea.vue?vue&type=template&id=f51fed44&scoped=true&"
import script from "./DynamicTextarea.vue?vue&type=script&lang=js&"
export * from "./DynamicTextarea.vue?vue&type=script&lang=js&"
import style0 from "./DynamicTextarea.vue?vue&type=style&index=0&id=f51fed44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51fed44",
  null
  
)

export default component.exports